<script setup lang="ts">
import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';
import {
  LAWYER_TYPE_LAWYER,
  LAWYER_TYPE_ADVOCATE,
} from '@/shared/constants/lawyerTypeConstants';
import {
  ORGANIZATION_TYPE_CLUB,
  ORGANIZATION_TYPE_BUREAU,
} from '@/shared/constants/organizationTypeConstants';
import { buildCatalogUrl } from '@/shared/utils/buildCatalogUrl';
import FooterCaption from '@/widgets/LawyerCard/ui/LawyerCardFooter/FooterCaption.vue';
import FooterProfileLink from '@/widgets/LawyerCard/ui/LawyerCardFooter/FooterProfileLink.vue';
import FooterContacts from '@/widgets/LawyerCard/ui/LawyerCardFooter/FooterContacts.vue';
import type { ILawyerCardFooterProps } from '@/widgets/LawyerCard/model/types/lawyerCard';
import type { ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

withDefaults(defineProps<ILawyerCardFooterProps>(), {
  isShowCaption: false,
  isCardSlider: false,
  isLawyerPage: false,
  isCatalog: false,
  isArticle: false,
});

const lawyerInfo = inject<ILawyerCardInfo>('lawyerInfo');

const companyId: ComputedRef<number | null | undefined> = computed(
  () => lawyerInfo?.company_id,
);
const role: ComputedRef<number | undefined> = computed(() => lawyerInfo?.role);

const linkToProfileCatalog: ComputedRef<string> = computed(() => {
  const region = lawyerInfo?.addresses?.length ? lawyerInfo.addresses[0]?.city?.slug : '';
  const isIndividual =
    (role.value === LAWYER_TYPE_LAWYER || role.value === LAWYER_TYPE_ADVOCATE) &&
    !companyId.value;
  const isOrganization =
    (role.value === ORGANIZATION_TYPE_CLUB || role.value === ORGANIZATION_TYPE_BUREAU) &&
    companyId.value;

  if (!isIndividual && !isOrganization) return ROOT_CATALOG_URL;

  const type = isIndividual ? 'lawyers' : 'organizations';
  return buildCatalogUrl({ segments: ['geo', region, type, lawyerInfo?.slug] });
});
</script>

<template>
  <FooterCaption
    v-if="isShowCaption"
    :link-to-profile-catalog="linkToProfileCatalog"
    :is-catalog="isCatalog"
    :is-slider="isCardSlider"
  />
  <FooterProfileLink
    v-else-if="isCardSlider || isArticle"
    :link-to-profile-catalog="linkToProfileCatalog"
    :is-article="isArticle"
  />
  <FooterContacts v-else-if="isLawyerPage" />
</template>
